import { Heading } from '@ksyos/design-system';

export function GroupSectionHeading(props: Readonly<{ sectionName: string }>): JSX.Element {
    return (
        <Heading
            fontWeight="medium"
            mb={7}
            pt={4}
            size="medium"
        >
            {props.sectionName}
        </Heading>
    );
}
